import { Box, Button, Card, CardContent, darken, Typography } from '@mui/material';
import { format } from 'date-fns';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IExpandedTourDate } from '../../models/IExpandedTourDate';
import ReservationModal from '../reservation/ReservationModal';

interface MobileViewProps {
    tourDates: IExpandedTourDate[];
    selectedTourId: number;
}

const MobileView: React.FC<MobileViewProps> = ({ tourDates, selectedTourId }) => {
    const { t } = useTranslation();

    const [selectedTour, setSelectedTour] = useState<IExpandedTourDate | null>(null);

    return (
        <>
            <Box display="flex" flexDirection="column" gap={2}>
                {tourDates.map(date => {
                    const isSelectedTour = date.tour.id === selectedTourId;
                    const isFull = date.availableSpots === 0;

                    return (
                        <Card
                            key={date.id}
                            sx={(theme) => ({
                                pb: 0,
                                borderRadius: 2,
                                position: "relative",
                                boxShadow: isSelectedTour ? "rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 1px 1px" : "none",
                                ...theme.applyStyles("dark", {
                                    bgcolor: theme.palette.background.default,
                                    boxShadow: "rgba(106, 116, 133, 0.25) 0px 1px 1px, rgba(106, 116, 133, 0.13) 0px 0px 1px 1px",
                                }),
                            })}
                        >
                            <CardContent
                                sx={{
                                    position: "relative",
                                    padding: "16px 16px!important",
                                    pt: "8px!important",
                                    boxShadow: "none"
                                }}>
                                <Typography
                                    variant='caption'
                                    color={isSelectedTour ? "text.primary" : "text.secondary"}
                                    fontWeight={isSelectedTour ? 700 : 500}
                                    position={"absolute"}
                                    top={10}
                                    right={16}
                                    sx={(theme) => ({
                                        backgroundColor: isSelectedTour ? darken(theme.palette.background.default, 0.1) : "none",
                                        borderRadius: "6px",
                                        px: "6px"
                                    })}
                                >
                                    {t(date.tour.name)}
                                </Typography>
                                <Typography fontWeight={600} color={"text2.primary"}>📅 {format(new Date(date.startDate), 'dd.MM.yyyy')} – {format(new Date(date.endDate), 'dd.MM.yyyy')}</Typography>
                                <Box display={"flex"} flexDirection={"row"} alignItems={"center"} gap={1} mt={0.5}>
                                    <Typography
                                        variant='caption'
                                        fontWeight={600}
                                        color={isFull ? "error.main" : "text2.secondary"}
                                        lineHeight={1}
                                    >
                                        {isFull
                                            ? t("tourDetails.common.terms.fullyBooked")
                                            : t("tourDetails.common.terms.availableSpots")}
                                    </Typography>
                                    {!isFull && (
                                        <Typography fontWeight={600} variant='subtitle2' color={"text2.secondary"}>
                                            {date.availableSpots}
                                        </Typography>
                                    )}
                                </Box>


                                {/* <Box mt={1} display={"flex"} flexDirection={"row"} justifyContent={"space-between"} width={"100%"} gap={1.5}>
                                <Box
                                    sx={(theme) => ({
                                        border: "1px solid #e1e4e9",
                                        borderRadius: "8px",
                                        pt: "6px",
                                        pb: "2px",
                                        bgcolor: "#f9f9fb",
                                        ...theme.applyStyles("dark", {
                                            bgcolor: "#2d343d",
                                            border: "1px solid #384049",
                                        })
                                    })}
                                    width={"100%"}
                                    display={"flex"} flexDirection={"column"} alignItems={"center"} justifyContent={"center"}>
                                    <Typography variant='caption' fontWeight={600} color={"text2.secondary"} lineHeight={1}>
                                        Slobodna mjesta
                                    </Typography>
                                    <Typography fontWeight={600} color={"text2.secondary"}>
                                        {date.availableSpots}
                                    </Typography>
                                </Box>
                                <Box
                                    sx={(theme) => ({
                                        border: "1px solid #e1e4e9",
                                        borderRadius: "8px",
                                        pt: "6px",
                                        pb: "2px",
                                        bgcolor: "#f9f9fb",
                                        ...theme.applyStyles("dark", {
                                            bgcolor: "#2d343d",
                                            border: "1px solid #384049",
                                        })
                                    })}
                                    width={"100%"}
                                    display={"flex"} flexDirection={"column"} alignItems={"center"} justifyContent={"center"}>
                                    <Typography variant='caption' fontWeight={600} color={"text2.secondary"} lineHeight={1}>
                                        Cijena
                                    </Typography>
                                    <Typography fontWeight={600} color={"#53c464ff"}>
                                        {date.tour.price} €
                                    </Typography>
                                </Box>
                            </Box> */}

                                <Button
                                    variant="outlined"
                                    color='secondary'
                                    disabled={isFull}
                                    fullWidth
                                    sx={(theme) => ({
                                        mt: 1.5,
                                        borderRadius: "8px",
                                    })}
                                    onClick={() => setSelectedTour(date)}
                                >
                                    <Box
                                        display={"flex"}
                                        flexDirection={"row"}
                                        position={"relative"}
                                        width={"100%"}
                                        alignItems={"center"}
                                        justifyContent={"center"}>
                                        <Typography variant='subtitle2'>{t("tourDetails.common.terms.reserve")}</Typography>
                                        {/* <Typography
                                        fontWeight={600}
                                        position={"absolute"}
                                        right={0}
                                        color={"main.primary!important"}>
                                        {date.tour.price} €
                                    </Typography> */}
                                    </Box>

                                </Button>
                            </CardContent>
                        </Card>
                    );
                })}
            </Box>

            <ReservationModal
                open={!!selectedTour}
                onClose={() => setSelectedTour(null)}
                tourDate={selectedTour}
            />
        </>
    )
}

export default MobileView;